// @ts-ignore - Vite handles JSON imports natively
import packageJson from '../../../package.json';

export interface PackageLicense {
  name: string;
  version: string;
  license: string;
  url?: string;
}

/**
 * Common license mappings for popular packages
 */
const knownLicenses: Record<string, string> = {
  'svelte': 'MIT',
  'svelte-i18n': 'MIT',
  '@tabler/icons-svelte': 'MIT',
  'vite': 'MIT',
  '@sveltejs/vite-plugin-svelte': 'MIT',
  'typescript': 'Apache-2.0',
  'tailwindcss': 'MIT',
  'vitest': 'MIT',
  '@playwright/test': 'Apache-2.0',
  'prettier': 'MIT',
  'eslint': 'MIT',
  'autoprefixer': 'MIT',
  'postcss': 'MIT',
  'svelte-check': 'MIT',
  'svelte-spa-router': 'MIT',
  '@testing-library/svelte': 'MIT',
  '@vitest/ui': 'MIT',
  'vite-plugin-pwa': 'MIT',
  'jsdom': 'MIT',
};

/**
 * Generate npm package URL
 */
function getNpmUrl(packageName: string): string {
  return `https://www.npmjs.com/package/${packageName}`;
}

/**
 * Get all package licenses from dependencies and devDependencies
 * Note: In a browser environment, we use known licenses and fallback to MIT
 * For production, consider generating this data at build time
 */
export async function getLicenses(): Promise<PackageLicense[]> {
  const allDeps = {
    ...packageJson.dependencies,
    ...packageJson.devDependencies,
  };

  const licenses: PackageLicense[] = [];

  for (const [name, version] of Object.entries(allDeps)) {
    const cleanVersion = version.replace(/^[\^~]/, '');
    const license = knownLicenses[name] || 'MIT';
    
    licenses.push({
      name,
      version: cleanVersion,
      license,
      url: getNpmUrl(name),
    });
  }

  // Sort by name
  licenses.sort((a, b) => a.name.localeCompare(b.name));

  return licenses;
}
